export class Constants {
  data: any = "data";
  shippingCharges = 100;
  token: any = "token";
  registered = "registered";
  checkRetailerRegistration = "cRR";
  authToken = "Auth-Token";
  url = "url"
  loggedInStatus = "lgdinstts";
  loggedIn = "loggedIn";
  navigateUrl = "navigateUrl";
  newToken = "updatedToken";
  storeUrl = "storeUrl";
  storeCode = 'storeCode';
  fofoCode = 'fofoCode';
  initPage = "/pages/checkRegistration";
  carts = "carts";
  lastOrder = "lastOrderHistory";
  pincode = "pc";
  androidOtp = "android.otpReceived";
  assetLink = "https://images.smartdukaan.com";
  selectedAddressId = 'adrsId';
  selfPickUp = 'slfPk';
  deliveryCharges = 'dlvryChrgs';
  myWalletUsed = "mWUsd";
  myWalletAmount = "mWAmnt";
  CODUsed = 'codUsd';
  paymentOptions: {
    POD: { title: "Pay On Delivery", code: "COD~3000", cod:false },
    EMIOD: { title: "EMI On Delivery", code: "EMIOD~3000", cod:false },
    RZ: { title: "Wallet/ Cards /Netbanking /UPI", code: "RZ~0000", cod:false },
    CCAVE : {title : "Other online Payments", code:"CCAVE~0000", cod:false}
  };
  paymentOptionUsed = 'pmntoptnusd';
  selectedPaymentOption = 'slctdPmntoptn';
  paymentId = 'pmntId';
  androidId = 'ndrdId';
  androidlogId="ddf";
  checkRetailer = ["retailer", "fofo", "verifiedRetailer", "fofoAssociate"];
  checkFofo = ["fofo"];
  checkFofoAssociate = ["fofoAssociate"]
  policy = 'policy';
  storeAuthorizedemail = 'storeAuthorizedemail'
  storeAddress = 'storeAddress';
  defaultAddress = 'defaultAddress';
  codStatus = 'codStatus'
  version = '1.5.5'
  rechargeObj = 'rechargeObj';
  rechargeoptName = 'rechargeoptName';
  holdDisable = 'holdDisable'
  states = [
    'Andaman & Nicobar Islands',
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chandigarh',
    'Chhattisgarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu & Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Lakshdweep',
    'Ladakh',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Orissa',
    'Pondicherry',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
  ];
  opeartorTypes = [
    'PREPAID',
    'POSTPAID'
  ];
  obj = {
    limit: 15,
    brand: "",
    offset: 0,
    categoryId: 3,
    subCategoryId: 0,
    q: ""
  };
  brands = ["Oppo","Vivo","Samsung","Xiaomi","Redmi","Motorola","Apple","POCO","Techno","Villaon","Realme","Lava","Itel","Cellecor","Almost New"];
}
